import React from "react";
import Chart from "react-apexcharts";

const SubscriptionChart = () => {
  const options = {
    chart: {
      type: "radialBar",
      sparkline: {
        enabled: true, // disables extra spacing
      },
    },
    colors: ["#043873"],
    plotOptions: {
      radialBar: {
        hollow: {
          size: "75%", // slightly smaller
        },
        track: {
          background: "#f1f1f1",
          strokeWidth: "50%",
          margin: 0,
        },
        dataLabels: {
          showOn: "always",
          name: {
            // offsetY: -5,
            // show: true,
            // color: "#888",
            // fontSize: "12px",
            show: false, 
          },
          value: {
            show: true,
            fontSize: "12px",
            fontWeight: 600,
            offsetY: 5,
            color: "#111",
          },
        },
      },
    },
    stroke: {
      lineCap: "round",
    },
    labels: [""],
  };

  const series = [67];

  return (
    <div style={{ width: "100%", maxWidth: "60px", margin: "auto" }} className="subscription">
      <Chart options={options} series={series} type="radialBar" height={60} />
    </div>
  );
};

export default SubscriptionChart;